import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { mainMenuItem } from './main-menu-items/main-menu-items';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 200,
        height: 'calc(100vh - 50px)',
        backgroundColor: '#808080',
        color: 'white',
        'border-right': '1px solid lightgrey',
    }
}));


const MainMenu: React.FC = () => {
    const classes = useStyles();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [t] = useTranslation();
    const navigate = useNavigate();
    const handleListItemClick = (event: any, index: number, path: string) => {
        setSelectedIndex(index);
        navigate(path);
    };
    useEffect(() => {
        const menuIndex = mainMenuItem.findIndex((mi) => window.location.pathname.includes(mi.path));
        if (menuIndex > 0) {
            setSelectedIndex(menuIndex);
        } else {
            setSelectedIndex(0)
        }
    }, [window.location.pathname]);
    return (
        <div className={classes.root + ' main-menu'}>
            <List component="nav" aria-label="main mailbox folders">
                {
                    mainMenuItem.map((item, index) => {
                        return (
                            <ListItem
                                button
                                key={'mainMenuItem.' + index}
                                selected={selectedIndex === index}
                                onClick={(event) => handleListItemClick(event, index, item.path)}>
                                <ListItemIcon>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primary={t('mainMenuItem.' + item.label)} />
                            </ListItem>
                        )
                    })
                }
            </List>
        </div>
    )
}

export default MainMenu;